import { useEffect, useState } from "react";
import { useLocation, useSearch } from "wouter";
import { RoomScreen } from "../games/common/RoomScreen";
import { useI18n } from "../i18n";
import { IS_DEMO } from "../lib/asset";
import { NetRoom } from "../lib/net-room";
import { seats } from "../lib/prefs";
import { useStore } from "../lib/store";

export function RoomPage({ code }: { code: string }) {
  const { d } = useI18n();
  const all = useStore(seats);
  const seat = all[code] ?? null;
  const search = useSearch();
  const tv = new URLSearchParams(search).get("tv") === "1";
  const [, nav] = useLocation();
  const [client, setClient] = useState<NetRoom | null>(null);

  useEffect(() => {
    if (IS_DEMO) return;
    if (!seat && !tv) {
      nav(`/j/${code}`, { replace: true });
      return;
    }
    const c = new NetRoom(code, tv ? null : seat);
    setClient(c);
    return () => c.close();
  }, [code, seat?.token, tv]); // eslint-disable-line react-hooks/exhaustive-deps

  if (IS_DEMO) return <div className="shell py-20 text-center text-xl text-ink-2">{d.demo.serverOnly}</div>;
  if (!client) return <div className="grid min-h-[70dvh] place-items-center text-xl font-bold text-ink-3">{d.room.connecting}</div>;
  return <RoomScreen client={client} tv={tv} />;
}
